import React, { createContext, useContext, useEffect, useState } from 'react';
import en from '../i18n/en';
import tr from '../i18n/tr';
import fr from '../i18n/fr';
import ar from '../i18n/ar';
import uk from '../i18n/uk';
import es from '../i18n/es';

const translations = { en, tr, fr, ar, uk, es };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
	const getInitialLang = () => {
		// 1. localStorage override
		const stored = typeof window !== 'undefined' && localStorage.getItem('locale');
		if (stored && translations[stored]) return stored;

		// 2. browser language (support fr, ar, tr, en and regional variants like 'fr-FR')
		const nav = typeof navigator !== 'undefined' ? navigator.language || navigator.userLanguage : 'en';
		const prefix = nav ? nav.toLowerCase().split('-')[0] : 'en';
		if (translations[prefix]) return prefix;

		// fallback to English
		return 'en';
	};

	const [locale, setLocale] = useState(getInitialLang);

	useEffect(() => {
		try {
			localStorage.setItem('locale', locale);
		} catch (e) {}
	}, [locale]);

	// Apply document language and direction (RTL for Arabic)
	useEffect(() => {
		if (typeof document !== 'undefined') {
			document.documentElement.lang = locale;
			document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
		}
	}, [locale]);

	const t = (key) => {
		return (translations[locale] && translations[locale][key]) || translations['en'][key] || key;
	};

	return <LanguageContext.Provider value={{ locale, setLocale, t }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext;
